import "./HomePage.css";
import React from "react";
import { ReactFlowProvider } from "reactflow";
import Equipo from "../../components/0. DashBoard/1. Equipos/Equipo";
import Asistencia from "../../components/0. DashBoard/2. Asistencias/AsistenciaModal";
import Counters from "../../components/0. DashBoard/3. Counters/Counters";
import Comentarios from "../../components/0. DashBoard/4. Comentarios/Comentarios";
import Workflow from "../../components/0. DashBoard/5. Workflow/Workflow";
import Whatsapp from "../../components/0. DashBoard/6. Whatsapp/Whatsapp";
import Cumpleaños from "../../components/0. DashBoard/7. Cumpleaños/Cumpleaños";
import Calendario from "../../components/0. DashBoard/8. Calendario/Calendario";
import Procesos from "../../components/0. DashBoard/9. Procesos/Procesos";
import Graficos from "../../components/0. DashBoard/0. Gráficos/Graficos";

const HomePage = () => {
  return (
    <>
      <Equipo />
      <Asistencia />
      <div id="Home-Upper">
        <div id="Home-Left">
          <Counters />
          <div id="Home-Left-Lower">
            <Whatsapp />
            <ReactFlowProvider>
              <Workflow />
            </ReactFlowProvider>
          </div>
        </div>
        <div id="Home-Right">
          <Comentarios />
        </div>
      </div>
      <div id="Home-Lower">
        <Cumpleaños />
        <Calendario />
        <Procesos />
        <Graficos />
      </div>
    </>
  );
};

export default HomePage;
